import { createSlice } from '@reduxjs/toolkit'

import { loadLookupsByType } from './lookups.actions'

const initialState = {
  byType: {},
  status: 'idle',
  error: null,
}

export const lookupsReducer = createSlice({
  name: 'lookups',
  initialState,
  reducers: {},
  extraReducers: {
    [loadLookupsByType.pending.toString()]: (state) => {
      state.status = 'loading'
      state.error = null
    },
    [loadLookupsByType.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.byType[action.payload.type] = action.payload.lookups
    },
    [loadLookupsByType.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer
